import { clsx, type ClassValue } from 'clsx';

/**
 * Utilitaire pour combiner des classes CSS conditionnelles
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}

/**
 * Génère un ID unique
 */
export function generateId(): string {
  return crypto.randomUUID();
}

/**
 * Debounce une fonction
 */
export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number
): (...args: Parameters<T>) => void {
  let timeout: NodeJS.Timeout;
  
  return (...args: Parameters<T>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}

/**
 * Vérifie si une chaîne est vide ou null
 */
export function isEmpty(value: string | null | undefined): boolean {
  return !value || value.trim().length === 0;
}

/**
 * Capitalise la première lettre
 */
export function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

/**
 * Tronque un texte avec ellipsis
 */
export function truncate(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
}

/**
 * Vérifie si une date est dans le passé
 */
export function isPastDate(date: string): boolean {
  return new Date(date) < new Date();
}

/**
 * Calcule la différence en jours entre deux dates
 */
export function daysDifference(date1: string, date2: string): number {
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  const diffTime = Math.abs(d2.getTime() - d1.getTime());
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}
